<template>
  <bs-modal
    name="simple-ok"
    :ok-title="$t('javascript.okay')"
    :cancel-title="$t('javascript.cancel')"
    disable-cancel
    small-modal

    :value="value"
    @input="$emit('input', $event)"
  >
    <p>
      <slot></slot>
    </p>
  </bs-modal>
</template>

<script>
  import BsModal from './bs_modal'

  export default {
    name: "simple-ok-modal",
    props: ['value'],
    components: {BsModal},
  }
</script>
